import type { StyleElements } from "replo-runtime/shared/utils/styles";
import type { CustomPropsRecord } from "schemas/component";
import type { ComponentConfig } from "../../components";

import { convertToLegacyProps } from "../../../shared/utils/props";

function getConfigurableProps(): CustomPropsRecord {
  return {
    _timerType: {
      name: "Countdown Type",
      type: "selectable",
      description:
        "Whether the timer should count down to a specific time, or count down for an amount of time after page load.",
      defaultValue: "date",
      selectableValues: {
        type: "options",
        options: [
          { label: "Specific Time", value: "date" },
          { label: "Time After Load", value: "afterLoad" },
        ],
      },
    },
    _timerLimit: {
      name: "Countdown Time",
      type: "timeInterval",
      description:
        "Time for the timer to count down. Once the timer reaches 0, it will stop.",
      defaultValue: { minutes: 15, hours: 0, seconds: 0, days: 0 },
      shouldDisplay: ({ component }) => {
        return (component.props._timerType ?? "date") === "afterLoad";
      },
    },
    _endTime: {
      name: "End Time",
      type: "date",
      description:
        "Date and time the countdown is counting down to, in your local timezone.",
      defaultValue: new Date().toISOString(),
      shouldDisplay: ({ component }) => {
        return (component.props._timerType ?? "date") === "date";
      },
    },
  };
}

const styleElements = {
  root: {},
} as const satisfies StyleElements;

const config = {
  renderData: {
    newInstancesUseNumbering: true,
    customProps: convertToLegacyProps(getConfigurableProps()),
    acceptsArbitraryChildren: () => true,
    isAlwaysDynamic: false,
    canvasIndicatorDragDirections: [],
    allowsLayoutModification: true,
    canContainChildren: true,
    styleElements,
  },
} satisfies ComponentConfig;

export default config;
